import React from 'react';

import goldFlower from '../../images/glod-flower-tassels.svg';
import blueFlower from '../../images/blue-flower-tassels.svg';

export interface FlowerProps {
  title: string;
  type: 'gold' | 'blue';
}

const Flower = (props: FlowerProps) => {
  return (
    <div className='flower-container'>
      <img src={props.type === 'gold' ? goldFlower : blueFlower} />
      <span>{props.title}</span>
    </div>
  );
};

export default Flower;
